import { VertSpacerSm } from '@apps-common/components/layout'

export const SimTypeCardSkeleton = () => (
  <div className='p-6 w-full bg-skeleton border border-skeleton-border rounded-3xl animate-pulse'>
    <div className='flex items-center justify-end gap-[5px] mb-[5px]'>
      <div className='avatar'>
        <div className='!flex w-9 items-center justify-center rounded-full bg-skeleton-hi' />
      </div>
      <div className='avatar'>
        <div className='!flex w-9 items-center justify-center rounded-full bg-skeleton-hi' />
      </div>
    </div>
    <VertSpacerSm />
    <div className='bg-skeleton-hi w-[50%] h-[20px] rounded-[10px]' />
    <VertSpacerSm />
    <div className='bg-skeleton-hi w-[70%] h-[20px] rounded-[10px]' />
  </div>
)
